/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createLogMessage } from '../fn/log-message-controller/create-log-message';
import { CreateLogMessage$Params } from '../fn/log-message-controller/create-log-message';
import { deleteLogMessage } from '../fn/log-message-controller/delete-log-message';
import { DeleteLogMessage$Params } from '../fn/log-message-controller/delete-log-message';
import { getLogMessage } from '../fn/log-message-controller/get-log-message';
import { GetLogMessage$Params } from '../fn/log-message-controller/get-log-message';
import { getLogMessages } from '../fn/log-message-controller/get-log-messages';
import { GetLogMessages$Params } from '../fn/log-message-controller/get-log-messages';
import { getLogMessagesFiltered } from '../fn/log-message-controller/get-log-messages-filtered';
import { GetLogMessagesFiltered$Params } from '../fn/log-message-controller/get-log-messages-filtered';
import { LogMessageDto } from '../models/log-message-dto';
import { PageLogMessageDto } from '../models/page-log-message-dto';
import { updateLogMessage } from '../fn/log-message-controller/update-log-message';
import { UpdateLogMessage$Params } from '../fn/log-message-controller/update-log-message';

@Injectable({ providedIn: 'root' })
export class LogMessageControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLogMessage()` */
  static readonly GetLogMessagePath = '/v1/logmessage/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLogMessage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogMessage$Response(params: GetLogMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<LogMessageDto>> {
    return getLogMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLogMessage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogMessage(params: GetLogMessage$Params, context?: HttpContext): Observable<LogMessageDto> {
    return this.getLogMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<LogMessageDto>): LogMessageDto => r.body)
    );
  }

  /** Path part for operation `updateLogMessage()` */
  static readonly UpdateLogMessagePath = '/v1/logmessage/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLogMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLogMessage$Response(params: UpdateLogMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<LogMessageDto>> {
    return updateLogMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLogMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLogMessage(params: UpdateLogMessage$Params, context?: HttpContext): Observable<LogMessageDto> {
    return this.updateLogMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<LogMessageDto>): LogMessageDto => r.body)
    );
  }

  /** Path part for operation `deleteLogMessage()` */
  static readonly DeleteLogMessagePath = '/v1/logmessage/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLogMessage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLogMessage$Response(params: DeleteLogMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteLogMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLogMessage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLogMessage(params: DeleteLogMessage$Params, context?: HttpContext): Observable<void> {
    return this.deleteLogMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getLogMessages()` */
  static readonly GetLogMessagesPath = '/v1/logmessage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLogMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogMessages$Response(params?: GetLogMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<PageLogMessageDto>> {
    return getLogMessages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLogMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogMessages(params?: GetLogMessages$Params, context?: HttpContext): Observable<PageLogMessageDto> {
    return this.getLogMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageLogMessageDto>): PageLogMessageDto => r.body)
    );
  }

  /** Path part for operation `createLogMessage()` */
  static readonly CreateLogMessagePath = '/v1/logmessage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLogMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLogMessage$Response(params: CreateLogMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<LogMessageDto>> {
    return createLogMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLogMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLogMessage(params: CreateLogMessage$Params, context?: HttpContext): Observable<LogMessageDto> {
    return this.createLogMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<LogMessageDto>): LogMessageDto => r.body)
    );
  }

  /** Path part for operation `getLogMessagesFiltered()` */
  static readonly GetLogMessagesFilteredPath = '/v1/logmessage/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLogMessagesFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getLogMessagesFiltered$Response(params: GetLogMessagesFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageLogMessageDto>> {
    return getLogMessagesFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLogMessagesFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getLogMessagesFiltered(params: GetLogMessagesFiltered$Params, context?: HttpContext): Observable<PageLogMessageDto> {
    return this.getLogMessagesFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageLogMessageDto>): PageLogMessageDto => r.body)
    );
  }

}
